module.exports = __webpack_public_path__ + "static/img/img5.573e789.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/simulator/img5.png
// module id = qbEQ
// module chunks = 1